// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-page {
  --terms-type-heading: clamp(2.2rem, 3.2vw, 3rem);
  --terms-type-subheading: 1.6rem;
  --terms-type-card-heading: 1.2rem;
  --terms-type-body: 1.05rem;
  --terms-type-label: 0.9rem;
  background: #d6c3d9;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  color: #0f172a;
  font-family: 'Inter', sans-serif;
  padding-top: 5.25rem;
}

.terms-hero {
  padding: 2.1rem 1rem 2.2rem;
  max-width: 1320px;
  margin: 0 auto;
}

.hero-path {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  font-size: var(--terms-type-label);
  color: #64748b;
}

.download-btn {
  background: #e0e7ff;
  border: none;
  border-radius: 999px;
  padding: 0.5rem 1.25rem;
  font-weight: 600;
  color: #400C4D;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
}

.hero-title-group h1 {
  font-size: var(--terms-type-heading);
  margin: 0;
}

.hero-title-group p {
  margin: 0.35rem 0 0;
  color: #94a3b8;
  font-size: var(--terms-type-body);
}

.terms-body {
  display: grid;
  grid-template-columns: minmax(220px, 0.9fr) minmax(0, 3.6fr);
  gap: 2rem;
  max-width: 1320px;
  margin: 0 auto 4rem;
  padding: 0 1rem 3rem;
}

.toc {
  background: #fff;
  border-radius: 1.5rem;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
  border: 1px solid #e2e8f0;
  position: sticky;
  top: 1.5rem;
  align-self: start;
}

.toc-title {
  font-size: var(--terms-type-label);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 1rem;
}

.toc ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.toc li a {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #0f172a;
  font-weight: 600;
  text-decoration: none;
  font-size: var(--terms-type-body);
}

.toc li span {
  font-size: 0.9rem;
  color: #400C4D;
  font-weight: 700;
}

.toc-cta {
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 1rem;
  background: #eef2ff;
  color: #400C4D;
  font-size: var(--terms-type-label);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.link-btn {
  background: transparent;
  border: none;
  color: #400C4D;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-align: left;
}

.terms-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.terms-section {
  background: #fff;
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.12);
  border: 1px solid #e2e8f0;
}

.section-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.section-number {
  background: #F6EEF8;
  color: #400C4D;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 0.95rem;
}

.terms-section h2 {
  margin: 0;
  font-size: var(--terms-type-subheading);
}

.terms-section p {
  margin-top: 0.65rem;
  color: #400C4D;
  line-height: 1.7;
  font-size: var(--terms-type-body);
}

.terms-kicker {
  font-weight: 700;
  color: #400C4D;
  font-style: italic;
}

.terms-subtitle {
  margin-top: 1.35rem;
  margin-bottom: 0.35rem;
  font-size: var(--terms-type-card-heading);
  color: #400C4D;
}

.terms-table {
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 0.6rem;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #c4b5d6;
  background: #ffffff;
}

.terms-table th,
.terms-table td {
  border: 1px solid #c4b5d6;
  padding: 0.6rem 0.7rem;
  text-align: left;
  vertical-align: top;
  font-size: 0.98rem;
  line-height: 1.45;
  word-break: break-word;
}

.terms-table th {
  background: #e9d5ff;
  color: #400C4D;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
}

.terms-note {
  margin-top: 0.5rem;
  color: #6b21a8 !important;
  font-size: 1rem;
  font-style: italic;
}

.terms-list {
  margin-top: 0.75rem;
  padding-left: 1.2rem;
}

.terms-list li {
  margin-bottom: 0.4rem;
  color: black;
  line-height: 1.6;
  font-size: var(--terms-type-body);
}

@media (max-width: 1024px) {
  .terms-body {
    grid-template-columns: 1fr;
    max-width: 100%;
    transform: none;
  }

  .toc {
    position: relative;
    top: 0;
  }

  .terms-hero {
    max-width: 100%;
    transform: none;
  }
}

@media (max-width: 640px) {
  .terms-hero {
    padding-top: 2.5rem;
  }

  .hero-title-group h1 {
    font-size: 2.15rem;
  }

  .terms-section {
    padding: 1.25rem;
    border-radius: 1.2rem;
  }

  .terms-section h2 {
    font-size: 1.35rem;
  }

  .terms-subtitle {
    font-size: 1rem;
  }

  .hero-path {
    flex-direction: column;
    align-items: flex-start;
  }

  .terms-body {
    padding: 0 0.75rem 2rem;
    gap: 1.25rem;
  }

  .toc {
    padding: 1.1rem;
    border-radius: 1.2rem;
  }

  .terms-table th,
  .terms-table td {
    font-size: 0.82rem;
    padding: 0.45rem 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Terms/terms.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;;IAEE,kBAAkB;IAClB,uBAAuB;EACzB;AACF","sourcesContent":[".terms-page {\n  --terms-type-heading: clamp(2.2rem, 3.2vw, 3rem);\n  --terms-type-subheading: 1.6rem;\n  --terms-type-card-heading: 1.2rem;\n  --terms-type-body: 1.05rem;\n  --terms-type-label: 0.9rem;\n  background: #d6c3d9;\n  min-height: 100vh;\n  width: 100%;\n  overflow-x: hidden;\n  color: #0f172a;\n  font-family: 'Inter', sans-serif;\n  padding-top: 5.25rem;\n}\n\n.terms-hero {\n  padding: 2.1rem 1rem 2.2rem;\n  max-width: 1320px;\n  margin: 0 auto;\n}\n\n.hero-path {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  font-size: var(--terms-type-label);\n  color: #64748b;\n}\n\n.download-btn {\n  background: #e0e7ff;\n  border: none;\n  border-radius: 999px;\n  padding: 0.5rem 1.25rem;\n  font-weight: 600;\n  color: #400C4D;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  cursor: pointer;\n}\n\n.hero-title-group h1 {\n  font-size: var(--terms-type-heading);\n  margin: 0;\n}\n\n.hero-title-group p {\n  margin: 0.35rem 0 0;\n  color: #94a3b8;\n  font-size: var(--terms-type-body);\n}\n\n.terms-body {\n  display: grid;\n  grid-template-columns: minmax(220px, 0.9fr) minmax(0, 3.6fr);\n  gap: 2rem;\n  max-width: 1320px;\n  margin: 0 auto 4rem;\n  padding: 0 1rem 3rem;\n}\n\n.toc {\n  background: #fff;\n  border-radius: 1.5rem;\n  padding: 1.5rem;\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);\n  border: 1px solid #e2e8f0;\n  position: sticky;\n  top: 1.5rem;\n  align-self: start;\n}\n\n.toc-title {\n  font-size: var(--terms-type-label);\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 1rem;\n}\n\n.toc ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.toc li a {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  color: #0f172a;\n  font-weight: 600;\n  text-decoration: none;\n  font-size: var(--terms-type-body);\n}\n\n.toc li span {\n  font-size: 0.9rem;\n  color: #400C4D;\n  font-weight: 700;\n}\n\n.toc-cta {\n  margin-top: 2rem;\n  padding: 1rem;\n  border-radius: 1rem;\n  background: #eef2ff;\n  color: #400C4D;\n  font-size: var(--terms-type-label);\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.link-btn {\n  background: transparent;\n  border: none;\n  color: #400C4D;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  text-align: left;\n}\n\n.terms-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.terms-section {\n  background: #fff;\n  border-radius: 1.5rem;\n  padding: 2rem;\n  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.12);\n  border: 1px solid #e2e8f0;\n}\n\n.section-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.section-number {\n  background: #F6EEF8;\n  color: #400C4D;\n  border-radius: 50%;\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.terms-section h2 {\n  margin: 0;\n  font-size: var(--terms-type-subheading);\n}\n\n.terms-section p {\n  margin-top: 0.65rem;\n  color: #400C4D;\n  line-height: 1.7;\n  font-size: var(--terms-type-body);\n}\n\n.terms-kicker {\n  font-weight: 700;\n  color: #400C4D;\n  font-style: italic;\n}\n\n.terms-subtitle {\n  margin-top: 1.35rem;\n  margin-bottom: 0.35rem;\n  font-size: var(--terms-type-card-heading);\n  color: #400C4D;\n}\n\n.terms-table {\n  width: 100%;\n  margin-top: 0.75rem;\n  margin-bottom: 0.6rem;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border: 1px solid #c4b5d6;\n  background: #ffffff;\n}\n\n.terms-table th,\n.terms-table td {\n  border: 1px solid #c4b5d6;\n  padding: 0.6rem 0.7rem;\n  text-align: left;\n  vertical-align: top;\n  font-size: 0.98rem;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.terms-table th {\n  background: #e9d5ff;\n  color: #400C4D;\n  font-weight: 700;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.terms-note {\n  margin-top: 0.5rem;\n  color: #6b21a8 !important;\n  font-size: 1rem;\n  font-style: italic;\n}\n\n.terms-list {\n  margin-top: 0.75rem;\n  padding-left: 1.2rem;\n}\n\n.terms-list li {\n  margin-bottom: 0.4rem;\n  color: black;\n  line-height: 1.6;\n  font-size: var(--terms-type-body);\n}\n\n@media (max-width: 1024px) {\n  .terms-body {\n    grid-template-columns: 1fr;\n    max-width: 100%;\n    transform: none;\n  }\n\n  .toc {\n    position: relative;\n    top: 0;\n  }\n\n  .terms-hero {\n    max-width: 100%;\n    transform: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .terms-hero {\n    padding-top: 2.5rem;\n  }\n\n  .hero-title-group h1 {\n    font-size: 2.15rem;\n  }\n\n  .terms-section {\n    padding: 1.25rem;\n    border-radius: 1.2rem;\n  }\n\n  .terms-section h2 {\n    font-size: 1.35rem;\n  }\n\n  .terms-subtitle {\n    font-size: 1rem;\n  }\n\n  .hero-path {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .terms-body {\n    padding: 0 0.75rem 2rem;\n    gap: 1.25rem;\n  }\n\n  .toc {\n    padding: 1.1rem;\n    border-radius: 1.2rem;\n  }\n\n  .terms-table th,\n  .terms-table td {\n    font-size: 0.82rem;\n    padding: 0.45rem 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
